import { useState } from "react";
import { FAITHS } from "./lunelle-data";
import { useAccount } from "./account";

const KEY = "lunelle-faith";
const valid = (id) => FAITHS.some((f) => f.id === id);

const initial = () => {
  const fromUrl = new URLSearchParams(window.location.search).get("faith");
  if (valid(fromUrl)) return fromUrl;
  const saved = window.localStorage.getItem(KEY);
  return valid(saved) ? saved : "spiritual";
};

export const savedFaith = () => {
  const saved = window.localStorage.getItem(KEY);
  return valid(saved) ? saved : "spiritual";
};

// Signed-in members read/write the faith saved on their account; visitors use this browser
export const useFaith = () => {
  const account = useAccount();
  const memberFaith = account?.user?.profile?.faith;
  const [local, setLocal] = useState(initial);
  const faith = valid(memberFaith) ? memberFaith : local;
  const setFaith = (id) => {
    setLocal(id);
    window.localStorage.setItem(KEY, id);
    if (account?.user) account.updateProfile({ faith: id }).catch(() => {});
  };
  return [faith, setFaith];
};
